import React from 'react';
import { useUserInfo } from '@/hooks';
import { userHasPermission, type ROLES } from './AppRoles';

export type AuthorizeProps = {
  permission: ROLES | readonly ROLES[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

const Authorize = ({
  permission,
  children,
  fallback = null,
}: AuthorizeProps) => {
  const { permissions } = useUserInfo();
  const allowed = userHasPermission(permissions, permission);

  if (allowed) {
    return <>{children}</>;
  }
  return <>{fallback}</>;
};

export default Authorize;
